import style from "./Footer.module.css";
import logo from '../images/whiteLogo.svg';
import facebook from '../images/icon-facebook.svg';
import youtube from '../images/icon-youtube.svg';
import twitter from '../images/icon-twitter.svg';
import pinterest from '../images/icon-pinterest.svg';
import insta from '../images/icon-instagram.svg';
import Button from '../UI/Button';

const Footer = () => {
    const logos =[facebook,youtube,twitter,pinterest,insta];
    const firstList = ['About Us', 'Contact', 'Blog'];
    const secondList = ['Careers','Support','Privacy Policy'];
  return (
    <footer className={style.footer}>
      <div className={style.col1}>
        <div className={style.img}>
          <img src={logo} alt="logo"/>
        </div>
        <ul className={style.socialContainer}>
            {logos.map(e=>
            <li className={style.socialList}>
                <a className={style.socialLink} href={`https://${e.slice(e.indexOf('-') + 1,e.indexOf('.'))}.com`}>
                    <img src={e} alt={`${e.slice(e.indexOf('-') + 1,e.indexOf('.'))}`} width="27rem"/>
                </a>
            </li>
            )}
        </ul>
      </div>

      <div className={style.col2}>
      <ul className={style.listContainer}>
            {firstList.map(e=>
            <li className={style.list}>
                <a className={style.link} href={`https://${e}`}>{e}
                </a>
            </li>
            )}
        </ul>
      </div>

      <div className={style.col3}>
      <ul className={style.listContainer}>
            {secondList.map(e=>
            <li className={style.list}>
                <a className={style.link} href={`https://${e}`}>{e}
                </a>
            </li>
            )}
        </ul>
      </div>

      <div className={style.col4}>
            <Button></Button>
            <p>© Easybank. All Rights Reserved</p>
      </div>
      
    </footer>
  );
};

export default Footer;
